import React, { memo } from 'react'
import { useTheme } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import {
  HistoryRounded as HistoricIcon,
  ChatBubbleRounded as AttendanceToolsIcon,
  MenuBookRounded as KnowledgeTreeIcon,
  InsertLink as LinkIcon,
} from '@material-ui/icons'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import Tooltip from '../../atoms/display/tooltip'
import IconButton from '../../atoms/inputs/iconButton'

import useStyles from './style'

function DockMenu({
  widgetSelected,
  handleSelectWidget,
  isTicket,
  haveLink,
  isAiSummaryEnabled,
}) {
  const classes = useStyles()
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <div className={classes.root}>
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className={classes.dock}>
            <Tooltip placement="left" title={t('commons.serviceTools')}>
              <div
                style={{
                  background: `${
                    widgetSelected === 'attendance'
                      ? theme.palette.background.paper
                      : 'none'
                  }`,
                  borderRadius: '8px 0 0 8px',
                }}
              >
                <IconButton
                  active={widgetSelected === 'attendance'}
                  color="primary"
                  onClick={() => handleSelectWidget('attendance')}
                  style={{ background: 'none' }}
                >
                  <AttendanceToolsIcon
                    style={{ color: theme.palette.primary.main }}
                  />
                </IconButton>
              </div>
            </Tooltip>
            <Tooltip placement="left" title={t('commons.treeOfKnowledge')}>
              <div
                style={{
                  background: `${
                    widgetSelected === 'knowledge'
                      ? theme.palette.background.paper
                      : 'none'
                  }`,
                  borderRadius: '8px 0 0 8px',
                }}
              >
                <IconButton
                  active={widgetSelected === 'knowledge'}
                  color="primary"
                  onClick={() => handleSelectWidget('knowledge')}
                  style={{ background: 'none' }}
                >
                  <KnowledgeTreeIcon
                    style={{ color: theme.palette.primary.main }}
                  />
                </IconButton>
              </div>
            </Tooltip>
            {!isTicket && (
              <Tooltip
                placement="left"
                title={t('commons.conversationHistory')}
              >
                <div
                  style={{
                    background: `${
                      widgetSelected === 'historic'
                        ? theme.palette.background.paper
                        : 'none'
                    }`,
                    borderRadius: '8px 0 0 8px',
                  }}
                >
                  <IconButton
                    active={widgetSelected === 'historic'}
                    color="primary"
                    onClick={() => handleSelectWidget('historic')}
                    style={{ background: 'none' }}
                  >
                    <HistoricIcon
                      style={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </div>
              </Tooltip>
            )}
            {haveLink && (
              <Tooltip
                placement="left"
                title={haveLink?.data?.title || t('commons.link')}
              >
                <div
                  style={{
                    background: `${
                      widgetSelected === 'link'
                        ? theme.palette.background.paper
                        : 'none'
                    }`,
                    borderRadius: '8px 0 0 8px',
                  }}
                >
                  <IconButton
                    active={widgetSelected === 'link'}
                    color="primary"
                    onClick={() => handleSelectWidget('link')}
                    style={{ background: 'none' }}
                  >
                    <LinkIcon style={{ color: theme.palette.primary.main }} />
                  </IconButton>
                </div>
              </Tooltip>
            )}
            {!isTicket && isAiSummaryEnabled && (
              <Tooltip
                placement="left"
                title={t('summary.conversationSummary')}
              >
                <div
                  style={{
                    background: `${
                      widgetSelected === 'summary'
                        ? theme.palette.background.paper
                        : 'none'
                    }`,
                    borderRadius: '8px 0 0 8px',
                  }}
                >
                  <IconButton
                    active={widgetSelected === 'summary'}
                    color="primary"
                    onClick={() => handleSelectWidget('summary')}
                    style={{ background: 'none' }}
                  >
                    <AutoFixHighIcon
                      style={{ color: theme.palette.primary.main }}
                    />
                  </IconButton>
                </div>
              </Tooltip>
            )}
          </div>
        </div>
      </>
    </div>
  )
}

export default memo(DockMenu)
